/**
 * TipTap Extensions Configuration
 *
 * Centralized configuration of all TipTap extensions for RichTextEditor.
 * Ensures consistency between editor instance and HTML generation.
 */

import StarterKit from '@tiptap/starter-kit'
// import TextAlign from '@tiptap/extension-text-align'
import { TextStyle } from '@tiptap/extension-text-style'
import { Color } from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'

/**
 * Default extensions for RichTextEditor
 *
 * Includes:
 * - StarterKit: Bold, Italic, Strike, Heading, Paragraph, Lists, Blockquote, History, Underline
 *   Code and CodeBlock are kept in schema to support existing saved content — toolbar buttons remain hidden
 * - TextStyle: Base text styles (required for Color)
 * - Color: Text color
 * - Highlight: Background color (marker)
 *
 * Disabled:
 * - TextAlign: Text alignment (not needed)
 */
export const richTextEditorExtensions = [
  StarterKit.configure({
    // Keep code/codeBlock in schema so existing content with these node types doesn't crash.
    // Toolbar buttons for both are hidden — users cannot create new code marks/blocks.
  }),
  // TextAlign.configure({
  //   types: ['heading', 'paragraph'],
  // }),
  TextStyle,
  Color,
  Highlight.configure({
    multicolor: true,
  }),
]
